export default {
  vdoSet: {
    id: '',
    degreeId: '',
    courseOutlineId: '',
    subjectGroupId: '',
    subjectId: '',
    subjectCode: '',
    teacherId: '',
    teacherCode: '',
    code: '',
    description: '',
    totalVdoLength: 0,
    vdoSetUnits: []
  },
  vdoSets: [],
  processing: false,
  error: null,
  success: null,
}



